// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1XByl","Logo":"Toolbar_Logo__280B3","DesktopOnly":"Toolbar_DesktopOnly__1H-Bs"};